import React from 'react';

function getSizeCss(size) {
    switch (size) {
        case 'small':
            return 'py-1 px-3 text-sm';
        case 'xsmall':
            return 'py-1 px-2 text-xs';
        default:
            return 'py-1 px-4';
    }
}
function getVariantCss(variant) {
    switch (variant) {
        case 'secondary':
            return 'bg-lilac-300 text-black';
        case 'primary':
            return 'bg-green text-white';
        case 'warn':
            return 'bg-yellow text-white';
        case 'danger':
            return 'bg-red-300 text-white';
        case 'white':
            return 'bg-white text-black';
        default:
            return 'bg-gray-200 text-black';
    }
}
const Badge = ({ className = '', label = '', size = 'medium', tagName = 'span', variant = 'default', ...props }) => {
    const Component = tagName;
    return (React.createElement(Component, { className: [
            'inline-flex items-center',
            'font-medium',
            'rounded-3xl',
            'select-none',
            getSizeCss(size),
            getVariantCss(variant),
            className,
        ].join(' '), ...props }, label));
};

export { Badge };
//# sourceMappingURL=Badge.js.map
